export const INDEX_PAGE = '/';
export const DASHBOARD_PAGE = '/dashboard';
export const FAQ_PAGE = '/faq';

export const FOUND_BLOCKS_PAGE = '/found_blocks';
export const WORKERS_PAGE = '/workers';
export const PROFILE_PAGE = '/profile';



// WEBPACK FOOTER //
// /src/configuration/paths.js